var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthOao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6351_174941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9934 11.4548C13.7189 11.4548 11.875 13.2987 11.875 15.5732C11.875 17.8478 13.7189 19.6917 15.9934 19.6917C18.2679 19.6917 20.1118 17.8478 20.1118 15.5732C20.1118 13.2987 18.2679 11.4548 15.9934 11.4548ZM15.3315 17.5588L13.8755 16.1027L14.6697 15.3085L15.3315 15.9703L17.3171 13.9848L18.1113 14.779L15.3315 17.5588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9936 10.3318C16.4279 10.3318 16.8498 10.3852 17.2536 10.4852L17.6464 10.0925C19.8321 7.90667 19.8321 4.35015 17.6464 2.16444C16.5876 1.10555 15.1798 0.522461 13.6824 0.522461C12.3651 0.522461 11.1173 0.973689 10.1153 1.80306C7.91518 -0.0138317 4.64242 0.106576 2.5846 2.1644C0.398883 4.35012 0.398883 7.90663 2.5846 10.0924L10.1155 17.6233L10.9054 16.8334C10.8054 16.4296 10.752 16.0076 10.752 15.5734C10.752 12.6832 13.1033 10.3318 15.9936 10.3318ZM9.33944 10.3906L7.76811 6.46226L7.06383 7.63609H4.87388V6.51288H6.42791L7.97003 3.94269L9.39391 7.50243L10.9391 4.02562L12.1938 7.78959L13.2152 6.51288H15.3571V7.63609H13.755L11.7811 10.1034L10.7893 7.12814L9.33944 10.3906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6351_174941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1694,
    height: 19.1694,
    fill: "white",
    transform: "translate(0.945312 0.522461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthOao);
export default __webpack_public_path__ + "static/media/health_OAO.c83ddf80eef4320e6fba3c0fb4b889c7.svg";
export { ForwardRef as ReactComponent };